document.addEventListener('DOMContentLoaded', function () {
  var slideshows = document.querySelectorAll('.hero-slideshow');

  slideshows.forEach(function (slideshow) {
    var slides = slideshow.querySelectorAll('.hero-slide');
    if (slides.length <= 1) return;

    var dots = slideshow.querySelectorAll('.hero-dot');
    var prevBtn = slideshow.querySelector('.hero-arrow-prev');
    var nextBtn = slideshow.querySelector('.hero-arrow-next');

    var current = 0;
    var total = slides.length;
    var autoplay = slideshow.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(slideshow.getAttribute('data-autoplay-speed'), 10) || 5000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + total) % total;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    // Pause on hover (desktop)
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    // Touch swipe support
    var touchStartX = 0;
    var touchEndX = 0;

    slideshow.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    slideshow.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          next();
        } else {
          prev();
        }
      }
      startAutoplay();
    }, { passive: true });

    startAutoplay();
  });
});